<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (tap)="closeModal()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <!--        <ion-buttons slot="end">-->
        <!--            <ion-button (tap)="scanCode()" size="small" color="medium">-->
        <!--                <ion-icon name="barcode" slot="icon-only"></ion-icon>-->
        <!--            </ion-button>-->
        <!--        </ion-buttons>-->
        <ion-searchbar [(ngModel)]="queryText" placeholder="Search Equip"></ion-searchbar>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="fetchEquipment($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Updating Equipment...">
        </ion-refresher-content>
    </ion-refresher>
    <ion-item [color]="count/detailLine.qty < 1 ? 'danger' : 'success'" class="ion-text-center">
        <ion-label>
            Selected {{count}} of {{detailLine.qty}}
        </ion-label>
    </ion-item>
    
    <ion-virtual-scroll [items]="equipmentList | filterDetailLine: queryText ">
        <ion-item *virtualItem="let item">
            <ion-label class="ion-text-wrap>">
                <p>{{item.equipment.description}}</p>
                <p>{{item.equipment.reg}}</p>
            </ion-label>
            <ion-checkbox [(ngModel)]="item.isChecked" (ionChange)="checkFulfil()" color="success"></ion-checkbox>
        </ion-item>
    </ion-virtual-scroll>
</ion-content>

<!--ion-virtual-scroll [items]="equipList | filterDetailLine: queryText">
    <ion-item *virtualItem="let e" (click)="checkPlantStatus(e)">
        <ion-label>
            <p *ngIf="e.description">{{e.description}}</p>
            <p *ngIf="e.typ === 'S' && document.documentType !== documentTypes.ORDER
            && document.documentType !== documentTypes.QUOTATION">Reg: {{e.reg}}</p>
        </ion-label>
        <ion-icon *ngIf="e.stat !== 1 && document.documentType === 1 && e.typ === 'S'" name="man" slot="end"></ion-icon>
    </ion-item>
</ion-virtual-scroll-->
